export default "__VITE_ASSET__928fa6b5__"